<template>
    <div>
        <div class="page_banner">
            <div class="content">
                <div class="title">{{ $t('track_1') }}</div>
                <!-- <div class="desc">Please enter the package information to complete the shipping estimate.</div> -->
            </div>
        </div>
        <div class="container m-50" style="max-width: 996px;">
            <div class="search_box">
                <a-input-search v-model="postNum" :placeholder="$t('track_3')" :enter-button="$t('track_2')"
                    size="large" @search="onSearch"></a-input-search>
            </div>
            <div class="history_list">
                <template v-for="item in historyList">
                    <div class="history_item" @click="onSearch(item)">
                        {{ item }}
                        <a-icon type="delete" @click.stop="onDelete(item)"></a-icon>
                    </div>
                </template>
                <div class="history_item" @click="onClearHistory" v-if="historyList.length">
                    {{ $t('track_4') }}
                    <a-icon type="close-o"></a-icon>
                </div>
            </div>
            <div class="result_box" v-if="data">
                <a-collapse v-model="activeKey">
                    <a-collapse-panel :key="data.postnum">
                        <template #header>
                            <div>{{ data.postnum }}</div>
                        </template>
                        <a-timeline v-if="data.showData.length">
                            <template v-for="(item, index) in data.showData">
                                <a-timeline-item :color="index == (data.showData.length - 1) ? '#0d6fba' : '#E5E5E5'">{{
                                    item.ptime }}
                                    {{ item.record_en }}</a-timeline-item>
                            </template>
                        </a-timeline>
                        <a-empty v-else></a-empty>
                    </a-collapse-panel>
                </a-collapse>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    name: 'Track',
    data() {
        return {
            activeKey: [],
            data: '',
            loading: false,
            status: '',
            postNum: '',

            historyList: [],
        }
    },

    created() {

        if (localStorage.getItem('history')) {
            this.historyList = JSON.parse(localStorage.getItem('history'));
        } else {
            this.historyList = [];
        }

        if (this.$route.query.postnum) {
            this.postNum = this.$route.query.postnum;
            this.onSearch();
        }
    },

    methods: {
        onSearch(postnum = '') {
            if (postnum) {
                this.postNum = postnum;
            }
            if (this.postNum) {
                let params = {};
                if (this.postNum) {
                    params.postnum = this.postNum;
                }
                this.loading = true;
                this.$HTTP.get("/en/En/track", { params }).then(res => {
                    this.loading = false;
                    if (res.data.sts == 1) {
                        res.data.data.showData = res.data.data.showData.reverse();
                        res.data.data.showData.forEach(item => {
                            item.ptime = moment(item.ptime * 1000).format('YYYY-MM-DD hh:mm:ss');
                        });
                        if (res.data.data.showData.length) {
                            this.data = res.data.data;
                            this.status = res.data.data.status;
                            this.activeKey = [res.data.data.postnum];

                            this.onSetHistory(res.data.data.postnum);
                        } else {
                            this.data = '';
                            this.status = '';
                            this.activeKey = [];
                            this.postNum = '';
                            this.$message.error('No tracking information was found');
                        }
                    }
                })
            }
        },

        onSetHistory(postnum) {
            if (this.historyList.indexOf(postnum) != -1) return;
            if (this.historyList.length >= 20) {
                this.historyList.shift();
            }
            this.historyList.push(postnum);
            localStorage.setItem('history', JSON.stringify(this.historyList));
        },


        // 清空历史记录
        onClearHistory() {
            this.historyList = [];
            localStorage.setItem('history', JSON.stringify(this.historyList));
        },

        onDelete(postnum) {
            let index = this.historyList.indexOf(postnum);
            this.historyList.splice(index, 1);
            localStorage.setItem('history', JSON.stringify(this.historyList));
        }

    }
}
</script>

<style lang="scss" scoped>
#track {}

.container {
    margin-right: auto !important;
    margin-left: auto !important;
}

.search_box {
    margin-top: 33px;
    margin-bottom: 18px;
}

.history_list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 17px;

    .history_item {
        height: 34px;
        line-height: 34px;
        color: #4F4F4F;
        background: #EFEFEF;
        flex: none;
        margin-bottom: 10px;
        padding: 0 15px;
        border-radius: 5px;
        cursor: pointer;
        margin-right: 20px;
    }
}

.ant-input-lg {
    height: 62px;
    font-size: 24px;
    padding-left: 22px;
    padding-right: 22px;
    border: none;
}

.ant-btn-lg {
    height: 62px;
    font-size: 24px;
    width: 186px;
}

.ant-collapse {
    border: none;
    background: #fff;
}

.ant-collapse>.ant-collapse-item:last-child {
    border: none;
    padding-bottom: 0 !important;
}

.ant-collapse>.ant-collapse-item>.ant-collapse-header {
    padding-top: 17px;
    padding-bottom: 14px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
}

.ant-collapse>.ant-collapse-item>.ant-collapse-header .ant-collapse-arrow {
    font-size: 16px;
    color: #333;
}

.ant-collapse-content {
    border-top-color: #EFEFEF;
}

.ant-collapse-content>.ant-collapse-content-box {
    padding: 23px;
}

.ant-timeline-item-content {
    color: #141414;
    font-weight: normal;
    font-size: 16px;
}
</style>